import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export enum PendingEquipmentChangeKind {
  TRUCK = 'truck',
  TRAILER = 'trailer',
  DRIVER = 'driver',
}

export interface PendingEquipmentChangeRow {
  id: string
  kind: PendingEquipmentChangeKind
  status: string
  orgId: string
  orgName: string
  label: string
  pendingSourceId: string | null
  dateCreated: string
}

export function getPendingEquipmentChanges(): Promise<PendingEquipmentChangeRow[]> {
  return axios
    .get('/api/v1/insure/internal/pending-equipment-changes/')
    .then((r) => toCamelCase(r.data) as PendingEquipmentChangeRow[])
}

export function usePendingEquipmentChanges() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [CacheKeys.PENDING_EQUIPMENT_CHANGES],
    queryFn: getPendingEquipmentChanges,
  })
  return { rows: data ?? [], isLoading, refetch }
}
